import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { PrepagaService } from './service/prepaga.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-prepaga',
  templateUrl: './prepaga.component.html',
  styleUrl: './prepaga.component.css',
  standalone: false
})
export class PrepagaComponent implements OnInit {
  @ViewChild('inputNombre', { static: false }) inputNombre?: ElementRef<HTMLInputElement>;
  tipoGrupo: 'solo' | 'pareja' | 'hijos' | 'familia' | '' = '';
  hijosOptions = [1, 2, 3, 4, 5, 6];
  provincias = [
    'Buenos Aires', 'CABA', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba', 'Corrientes',
    'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja', 'Mendoza', 'Misiones',
    'Neuquén', 'Río Negro', 'Salta', 'San Juan', 'San Luis', 'Santa Cruz',
    'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'
  ];
  formPrepaga: FormGroup;
  cantidadHijos = 0;
  hijosArray: number[] = [];
  token: string | null = null;
  uuid: string | null = null;

  constructor(
    private fb: FormBuilder,
    private _prepagaService: PrepagaService,
    private route: Router,
    private relativa: ActivatedRoute
  ) {
    this.formPrepaga = this.fb.group({
      nombre: ['', Validators.required],
      apellido: ['', Validators.required],
      edad: ['', [Validators.required, Validators.min(0)]],
      edadPareja: [''],
      cantidadHijos: [0],
      localidad: ['', Validators.required],
      provincia: ['', Validators.required],
      documento: ['', Validators.required],
      trabajo: ['', Validators.required],
      telefono: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit() {
    // No seleccionar ningún grupo por defecto
  }

  setGrupo(tipo: 'solo' | 'pareja' | 'hijos' | 'familia') {
    this.tipoGrupo = tipo;
    // Reset hijos y pareja
    this.formPrepaga.patchValue({ cantidadHijos: 0, edadPareja: '' });
    this.cantidadHijos = 0;
    this.hijosArray = [];
    // Limpiar controles de hijos
    this.removeHijosControls();
    if (tipo === 'pareja') {
      this.formPrepaga.get('edadPareja')?.setValidators([Validators.required, Validators.min(0)]);
    } else {
      this.formPrepaga.get('edadPareja')?.clearValidators();
      this.formPrepaga.get('edadPareja')?.setValue('');
    }
    this.formPrepaga.get('edadPareja')?.updateValueAndValidity();

      // Intentar desplazar la vista al campo nombre y darle foco.
      // En móviles a veces el focus no hace scroll correctamente, por eso
      // usamos scrollIntoView antes de focus y damos un delay un poco mayor
      // para esperar a que Angular renderice el formulario.
      setTimeout(() => {
        const el = this.inputNombre?.nativeElement;
        if (el) {
          try {
            // Primero intentamos desplazar suavemente el elemento al centro de la pantalla
            el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
          } catch (e) {
            // scrollIntoView puede fallar en algunos entornos; ignoramos el error
          }
          // Después pedimos foco (algunos móviles necesitan el scroll previo)
          try {
            el.focus();
          } catch (e) {
            // si focus falla, no romper la ejecución
          }
        }
      }, 300);
  }

  onCantidadHijosChange() {
    this.cantidadHijos = this.formPrepaga.get('cantidadHijos')?.value || 0;
    this.hijosArray = Array(this.cantidadHijos).fill(0);
    this.removeHijosControls();
    for (let i = 0; i < this.cantidadHijos; i++) {
      const controlName = 'edadHijo' + i;
      if (!this.formPrepaga.contains(controlName)) {
        this.formPrepaga.addControl(controlName, new FormControl('', [Validators.required, Validators.min(0)]));
      }
    }
    // Eliminar controles sobrantes si se reduce la cantidad
    let idx = this.cantidadHijos;
    while (this.formPrepaga.contains('edadHijo' + idx)) {
      this.formPrepaga.removeControl('edadHijo' + idx);
      idx++;
    }
  }

  removeHijosControls() {
    let idx = 0;
    while (this.formPrepaga.contains('edadHijo' + idx)) {
      this.formPrepaga.removeControl('edadHijo' + idx);
      idx++;
    }
  }

  enviar() {
    if (!this.formPrepaga.valid) return;
    this.token = localStorage.getItem('token');
    this.uuid = localStorage.getItem('uuid');
    this._prepagaService.nuevo_prospecto(this.token, this.formPrepaga.value, this.uuid).subscribe(
      (response) => {
        if (response.status === 'OK') {
          this.route.navigate(['./gracias'], { relativeTo: this.relativa });
        } else {
          alert('Error al enviar los datos. Por favor, inténtelo de nuevo más tarde.');
        }
      }
    );
  }
}
